import React, { useEffect, useRef } from "react";
import { connect, ConnectedProps } from "react-redux";
import { buildBuilding, closeDialog } from "../../../store/actions";
import buildings from "../../../assets/images/buildings/buildings";
import { systemClass } from "../../../lib/enums";
import { setSameHeight } from "../../../lib/elementUtilities";
import { SlotType } from "../../../lib/types";
import BuildingDetailInfoIcon from "../../ContentPopup/Contents/Headquarters/BuildingDetailInfoIcon";

interface IProps {
  availableBuildings: SlotType[];
  slotPrices: any;
}

const mapStateToProps = (state: any) => ({
  gold: state.governorate.resources.gold,
  bricks: state.governorate.resources.bricks,
  powerPoints: state.governorate.resources["power-points"] || 0
})

const mapDispatchToProps = (dispatch: any) => ({
  buildBuildingDispatch: (slotId: number, buildingTypeId: number) => dispatch(
    buildBuilding(slotId, buildingTypeId)
  ),
  closeDialogDispatch: () => dispatch(closeDialog())
});

const connector = connect(mapStateToProps, mapDispatchToProps);

const NewBuilding = ({
  availableBuildings,
  slotPrices,
  gold,
  bricks,
  powerPoints,
  buildBuildingDispatch,
  closeDialogDispatch
}: IProps & ConnectedProps<typeof connector>) => {
  const buildingsRowRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setSameHeight(buildingsRowRef.current || undefined);
  }, [availableBuildings]);

  // const availableIds = Object.values(availableBuildings).map(b => b.id);

  return (
    <section className="boxes-group">
      <span className="divider"/>
      <div className="box" style={{ overflowX: "auto" }}>
        <a href="#" onClick={closeDialogDispatch} className="dismiss">×</a>
        <div className="persons row" ref={buildingsRowRef} style={{ display: "inline-flex" }}>
          {
            Object.values(availableBuildings).map((building: any) => {
              // const built = possible && !availableIds.includes(building.id);
              const requirementsFulfilled = (building)?.requirementsFulfilled;
              const canBeBuilt = requirementsFulfilled
                && slotPrices[building.id].gold <= gold
                && slotPrices[building.id].bricks <= bricks
                && slotPrices[building.id].powerPoints <= powerPoints;
              return (
                <div className={"col-sm-6"} style={{ width: "200px" }}>
              <span className={`person ${systemClass.MatchHeight} 
              ${/* !built && */ !canBeBuilt ? "disabled" : ""}`}
                    style={{ display: "flex", flexFlow: "column", alignItems: "center" }}
              >
                <img
                  src={buildings[`b${building.imageId}`]}
                  width={"100px"}
                  height={"107px"}
                  alt=""
                  className="photo"
                />
                <h3 className="name">
                  {building.name}&nbsp;
                  <BuildingDetailInfoIcon
                    slotType={building}
                    selectedBuilding={building.id}
                  />
                </h3>
                <p>
                  <span className="white">
                    {[15, 16, 17, 18, 19, 20].includes(building.chain)
                    && <p>Exclusive with other guilds</p>}
                    {[29, 30, 31].includes(building.chain)
                    && <p>Exclusive with other manufactories</p>}
                    {!!building.prerequisities && <p>
                      Requires:<br/>
                      {building.prerequisities}
                    </p>}
                    {!building.requirementsDevelopmentFulfilled && <p>
                      Unlock in development
                    </p>}
                    <em>{slotPrices[building.id].gold}</em>&nbsp;
                    <i className={"icon icon-xs icon-zlato gold middle"}/>
                    + <em>{slotPrices[building.id].bricks}</em>&nbsp;
                    <i className={"icon icon-xs icon-infrastrukturni-body middle"}/>
                    {!!slotPrices[building.id].powerPoints && <>
                        + <em>{slotPrices[building.id].powerPoints}</em>&nbsp;
                      <i className={"icon icon-xs icon-pozemky middle"}/>
                    </>}
                  </span><br/>
                  {building.turns} turns
                </p>
                <div style={{
                  display: "flex",
                  height: "100%",
                  alignContent: "end",
                  alignItems: "end",
                }}>
                <a
                  href="#"
                  onClick={() => canBeBuilt && buildBuildingDispatch(0, building.id)}
                  className={`btn btn-blank ${!canBeBuilt ? "disabled" : ""}`}
                >
                  Build
                </a>
                </div>
              </span>
                </div>
              )
            })
          }
        </div>
      </div>
      <span className="divider"/>
    </section>
  )
}

export default connector(NewBuilding);
